const emptyAudioUrl =
  'data:audio/mpeg;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU4LjQ1LjEwMAAAAAAAAAAAAAAA//tQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAASW5mbwAAAA8AAAACAAACCQCysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKy//////////////////////////////////////////////////////////////////8AAAAATGF2YzU4LjkxAAAAAAAAAAAAAAAAJAUHAAAAAAAAAgnL8p2iAAAAAAAAAAAAAAAAAAAAAP/7MGQACXD6JScQYB6CEaBEFQxjAEOQkLLAgFYINQXRlFGAcITADOFX9HPpwnNEL+u5cREw4v/+F/ErucdAAQVEIIaCAAAhKHLIwzDhg8PPd/9DzxCADNkjZAGhsABjBJGwTZDKzJGT/3/+qMdBJz4KyAjAtDUtZdHXn4+90OoAAEoCACaJmiZMKE1JiY1KHRIMSxqoYwpL//LEgv/7MmQOj/DxEinIIRhQCUAEtAAiAQAAAaQAAAAgAAA0gAAABLSAABhh/2v34TGVTEFNRTMuMTAwVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVU=';
(function () {
  const touchHandler = () => {
    Browser.Touched = true;
    document.removeEventListener('touchend', touchHandler, false);
  };
  document.addEventListener('touchend', touchHandler, false);
})();
export const Browser = {
  Touched: false,
  Audio: {
    emptyAudioUrl,
    canAutoPlay: (function () {
      const audio = new Audio();
      audio.src = emptyAudioUrl;
      // audio.muted = true; // ios 浏览器可以静音播放，桌面端 chrome 不可以静音播放
      return audio
        .play()
        .then(() => {
          return true;
        })
        .catch(() => {
          return false;
        });
    })(),
  },
};
